/**
 * ? @description : Line Chart Based on Students Count by Level
 */

// Dependencies
import React, { Fragment, useEffect, useState, memo } from "react";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Legend,
  Title,
  Tooltip,
} from "chart.js";
import { Line } from "react-chartjs-2";

//Axios
import Axios from "../../../../axios/Axios";

//Redux dependecies
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../../redux/features/appSlice";
import axios from "axios";

// Register Chart Properties
ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title
);

function StudentsLevelCount() {

  const dispatch = useDispatch();
  const [studentLevelName, setStudentLevelName] = useState([]);
  const [studentLevel, setStudentLevel] = useState([]);

  useEffect(() => {
    const controller = axios.CancelToken.source();
    (async () => {
      try{
        const options = {
          method: "get",
          url: "dashboard/studentslevelcount",
          auth: true,
          data: null,
          token:{cancelToken: controller.token}
        };
  
        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token,
          );
        
        let levelName = response.data.map(data => `Level ${data.level_id}`);
        let level = response.data.map(data => data.student_level_count);
        
        setStudentLevelName(levelName);
        setStudentLevel(level);

      }catch(error){
        if(!axios.isCancel(error)){ 
          dispatch(
            showSnackbar({
              message: "Couldn't able to retrieve student performance graph",
              severity: "error",
            })
          )}
      }
    })()
    return () => {
      controller.cancel();
  }
  }, [dispatch])
  // console.log(studentLevel);
  // console.log(studentLevelName);

  let data = {
    labels: studentLevelName,
    datasets: [
      {
        label: "Students Count Based On Levels",
        data: studentLevel,
        fill: false,
        
        backgroundColor: ["rgba(19, 41, 112, 0.5)"],
        borderColor: ["rgba(19, 41, 112, 1)"],
        borderWidth: 1,
      },
    ],
  };

  let options = {
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
      },
    },
    legend: {
      labels: {
        fontSize: 16,
     
      },
      
    },
  };

  const plugins = [
    {
      afterDraw: function (chart) {
        if (chart.data.datasets[0].data.length < 1) {
          let ctx = chart.ctx;
          let width = chart.width;
          let height = chart.height;
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.font = "15px Arial";
          ctx.fillText("No data to display", width / 2, height / 2);
          ctx.restore();
        }
      },
    },
  ];

  return (
    <Fragment>
      <Line height={300} data={data} options={options} plugins={plugins}  />
    </Fragment>
  );
}

export default memo(StudentsLevelCount);
